<template>
    <ul>
        <li v-for="item in section">
            <ProLink v-if="item.to && item.to.name" :to="item.to" :title="item.alt ? item.alt : item.title" :target="item.external ? '_blank' : '_self'">{{
                item.title
            }}</ProLink>
            <ProLink
                v-else-if="item.to"
                v-fathom-event:click="item.fathomEvent ? [item.fathomEvent] : null"
                :href="item.to"
                :title="item.alt ? item.alt : item.title"
                :target="item.external ? '_blank' : '_self'"
                >{{ item.title }}</ProLink
            >
            <button v-else-if="item.action" @click="item.action" class="pro-link" :title="item.alt ? item.alt : item.title">{{ item.title }}</button>

            <template v-else>{{ item.title }}</template>
        </li>
    </ul>
</template>

<script>
export default {
    props: {
        section: Array,
    },
};
</script>
